import { get } from '@/api/implementation/app/index.js';

export const eventTypeSelect = () =>
  get('webhook-event/autocomplete'); //@TODO this shouldn't be an autocomplete url, since its not paginated
